"use client";

import { io } from "socket.io-client";
const isBrowser = typeof window !== "undefined";

const URL = `${process.env.NEXT_PUBLIC_APP_BE_ORIGIN ?? "http://localhost:4000"}/events`;
export const socket = isBrowser
  ? io(URL, {
      withCredentials: true,
      transports: ["websocket"],
    })
  : ({} as ReturnType<typeof io>);
